"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/styles");
var _clsx10 = _interopRequireDefault(require("clsx"));
var _Visibility = _interopRequireDefault(require("@material-ui/icons/Visibility"));
var _VisibilityOff = _interopRequireDefault(require("@material-ui/icons/VisibilityOff"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _ArrowBackIos = _interopRequireDefault(require("@material-ui/icons/ArrowBackIos"));
var _Typography = require("./Typography");
var _pittaModules = require("@thingsw/pitta-modules");
var _IconButton = require("./IconButton");
var _Button = require("./Button");
var _excluded = ["SecondaryColor", "pattern", "inputmode", "defaultText", "rootRef", "style", "label", "error", "disabled", "helperText", "helperTextNoWrap", "startIcon", "createPW", "mode", "password", "search", "card", "className", "count", "add", "countDense", "maxLength", "type", "variant", "onOpenSearch", "onCloseSearch", "onPlus", "onMinus", "onSearch", "MinusButtonDis", "PlusButtonDis", "startIconClassName", "inputTextCenter", "readOnly", "select", "endIcon", "active", "inputClassName", "requestSearchClose", "autoFocus", "inputID", "outlinedInputClassName", "startText", "simAdmin", "multiline", "setting", "autoComplete", "isFleetaCameraSearch", "onClear"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyle = (0, _core.makeStyles)(function (theme) {
  return {
    textFiledWrap: {
      position: "relative",
      width: function width(props) {
        return props.add ? "auto" : "100%";
      },
      display: "flex",
      alignItems: function alignItems(props) {
        return props.count ? "auto" : "center";
      },
      justifyContent: "flex-end"
    },
    root: {
      transition: function transition(props) {
        return props.simAdmin ? "" : theme.transitions.create("width");
      },
      // transition: theme.transitions.create("width"),
      width: function width(props) {
        if (props.search) {
          return 24;
        }
      },
      "& legend": theme.direction === "rtl" ? {
        textAlign: "right",
        marginRight: 2
      } : {
        marginLeft: 2
      },
      "& .MuiOutlinedInput-root": {
        cursor: function cursor(props) {
          if (props.select && props.disabled || props.disabled) {
            return "default";
          } else if (props.select) {
            return "pointer";
          } else {
            return "text";
          }
        }
      }
    },
    rootOpen: {
      width: "100%!important"
    },
    rootSearch: {
      overflow: "hidden"
    },
    label: function label(props) {
      return _objectSpread({
        // transform: "translate(14px, 10px) scale(1)",
        transform: props.dense ? "translate(14px, 7px) scale(1)" : "translate(14px, 10px) scale(1)"
      }, theme.direction === "rtl" && {
        transformOrigin: "top right",
        right: 28,
        left: "auto"
      });
    },
    formControl: _objectSpread({
      color: _pittaModules.LightColors.primary["3"],
      marginLeft: 2,
      "&$disabled": {
        color: "".concat(_pittaModules.LightColors.primary["3"], "5A")
      },
      "&$error": {
        color: _pittaModules.LightColors.secondary["11"]
      }
    }, theme.direction === "rtl" && {
      marginLeft: 0,
      marginRight: 2
    }),
    shrink: {
      marginTop: -2
    },
    outlinedInputOpen: {
      padding: function padding(props) {
        if (theme.direction === "rtl" && props.dense && props.startIcon) {
          return "6px 5px 6px 8px!important";
        } else if (props.dense && props.startIcon) {
          return "6px 8px 6px 5px!important";
        } else if (theme.direction === "rtl" && props.dense) {
          return "6px 16px 6px 11px!important";
        } else if (props.dense) {
          return "6px 11px 6px 16px!important";
        } else if (theme.direction === "rtl") {
          return "10px 16px 10px 13px!important";
        } else {
          return "10px 13px 10px 16px!important";
        }
      }
    },
    outlinedInput: {
      transition: function transition(props) {
        return props.simAdmin ? "" : theme.transitions.create(["width", "padding"]);
      },
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      // UXUI 둥근 디자인으로 전체 적용 (LEEHJ)
      borderRadius: function borderRadius(props) {
        if (props.count || props.countDense) {
          if (theme.direction === "rtl") {
            return theme.spacing(0, 1.25, 1.25, 0);
          } else {
            return theme.spacing(1.25, 0, 0, 1.25);
          }
        } else {
          return theme.spacing(1.25);
        }
      },
      padding: function padding(props) {
        if (props.search) {
          return 0;
        } else if (theme.direction === "rtl" && props.dense && props.startIcon) {
          return "6px 5px 6px 8px";
        } else if (props.dense && props.startIcon) {
          return "6px 8px 6px 5px";
        } else if (theme.direction === "rtl" && props.dense) {
          return "6px 16px 6px 11px";
        } else if (props.dense) {
          return "6px 11px 6px 16px";
        } else if (theme.direction === "rtl") {
          return "10px 16px 10px 13px";
        } else {
          return "10px 13px 10px 16px";
        }
      }
      // "& fieldset": {
      //   // borderWidth: "1px!important",
      // },
    },

    outlinedInputSetting: _defineProperty({
      borderRadius: "12px !important",
      padding: "8px 16px !important",
      justifyContent: "flex-start !important"
    }, theme.breakpoints.up("sm"), {
      padding: "8px 24px !important"
    }),
    focused: {
      "& > fieldset.MuiOutlinedInput-notchedOutline": {
        borderWidth: "1px!important",
        borderColor: "".concat(_pittaModules.LightColors.primary["7"], " !important")
      }
    },
    focusedErrorActive: {
      "& > fieldset.MuiOutlinedInput-notchedOutline": {
        borderWidth: "1px!important",
        borderColor: ""
      }
    },
    focusedNotActive: {
      "& > fieldset.MuiOutlinedInput-notchedOutline": {
        borderWidth: "1px!important",
        borderColor: "".concat(_pittaModules.LightColors.primary["4"], " !important")
      }
    },
    disabled: {},
    error: {
      "& > fieldset.MuiOutlinedInput-notchedOutline": {
        borderWidth: "1px!important",
        borderColor: "".concat(_pittaModules.LightColors.secondary["11"], "!important")
      }
    },
    input: {
      height: 24,
      padding: 0,
      cursor: function cursor(props) {
        if (props.select && props.disabled || props.disabled) {
          return "default";
        } else if (props.select) {
          return "pointer";
        } else {
          return "text";
        }
      }
    },
    inputSetting: {
      width: "27px",
      textAlign: "right"
    },
    inputCenter: {
      textAlign: "center"
    },
    notchedOutlineOpen: {
      borderWidth: "1px!important"
    },
    notchedOutline: function notchedOutline(props) {
      return {
        borderWidth: props.search ? 0 : 1,
        // top: -6,
        transition: theme.transitions.create("border-width"),
        borderColor: "".concat(_pittaModules.LightColors.primary["4"], "!important"),
        "& span": {
          fontSize: "0.75rem !important"
        },
        top: props.count ? -6 : -5
      };
    },
    notchedOutlineActive: {
      borderColor: "".concat(_pittaModules.LightColors.primary["7"], "!important")
    },
    positionStart: {
      marginRight: 0
    },
    positionEnd: {
      marginLeft: 0
    },
    showIcon: _objectSpread({
      padding: theme.spacing(0.375),
      "&:disabled": {
        color: "".concat(_pittaModules.LightColors.primary["3"], "5A")
      }
    }, theme.direction === "rtl" ? {
      marginRight: 5
    } : {
      marginLeft: 5
    }),
    searchIconStandard: {
      "& svg": {
        fontSize: "1.5rem!important"
      }
    },
    outlinedInputClose: {
      "& fieldset": {
        borderWidth: 0
      }
    },
    searchIconCloseOulined: {
      "& svg": {
        fontSize: "1.5rem!important"
      }
    },
    searchIcon: {
      padding: theme.spacing(0.75),
      "& svg": {
        fontSize: "1.125rem"
      },
      "&:disabled": {
        color: "".concat(_pittaModules.LightColors.primary["3"], "5A")
      },
      margin: function margin(props) {
        if (theme.direction === "rtl" && props.dense && props.startIcon) {
          return "0px 0px 0px 1px";
        } else if (props.dense && props.startIcon) {
          return "0px 1px 0px 0px";
        } else if (theme.direction === "rtl") {
          return "0px 0px 0px 3px";
        } else {
          return "0px 3px 0px 0px";
        }
      }
    },
    helperText: function helperText() {
      return _objectSpread({
        margin: theme.spacing(0.375, 2, 0, 2)
      }, theme.direction === "rtl" && {
        textAlign: "right"
      });
    },
    adminHelperText: {
      margin: "0 16px !important"
    },
    nowrap: {
      whiteSpace: "nowrap"
    },
    progressWrap: {
      position: "absolute",
      top: 38,
      width: "100%"
    },
    progress: {
      height: 4,
      width: "99.1%",
      margin: "0 auto",
      borderRadius: 2
    },
    colorPrimary: {
      backgroundColor: _pittaModules.LightColors.primary["6"]
    },
    bar: {
      borderRadius: 2,
      backgroundColor: function backgroundColor(props) {
        if (props.mode === "fail") {
          return _pittaModules.LightColors.secondary["11"];
        } else if (props.mode === "warning") {
          return _pittaModules.LightColors.secondary["17"];
        } else if (props.mode === "success") {
          return _pittaModules.LightColors.secondary["15"];
        }
      },
      minusborder: {
        "&:disabled": {
          border: "1px solid #000000"
        }
      }
    },
    buttonDisabled: {
      "&.Mui-disabled": {
        borderColor: _pittaModules.LightColors.primary["4"]
      }
    },
    inputSearchUnderline: {
      "&:hover:after, &:hover:before": {
        border: "0!important"
      },
      "&:after, &:before": {
        border: 0
      }
    },
    pd910: {
      padding: "9px 10px"
    },
    settingDefaultTextStyle: {
      marginTop: 1,
      marginLeft: 5
    },
    btnPlus: {
      borderTopRightRadius: 10,
      borderBottomRightRadius: 10
    }
  };
});
var Input = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var SecondaryColor = props.SecondaryColor,
    pattern = props.pattern,
    inputmode = props.inputmode,
    defaultText = props.defaultText,
    rootRef = props.rootRef,
    style = props.style,
    label = props.label,
    error = props.error,
    disabled = props.disabled,
    helperText = props.helperText,
    helperTextNoWrap = props.helperTextNoWrap,
    startIcon = props.startIcon,
    createPW = props.createPW,
    mode = props.mode,
    password = props.password,
    search = props.search,
    card = props.card,
    className = props.className,
    count = props.count,
    add = props.add,
    countDense = props.countDense,
    maxLength = props.maxLength,
    type = props.type,
    variant = props.variant,
    onOpenSearch = props.onOpenSearch,
    onCloseSearch = props.onCloseSearch,
    onPlus = props.onPlus,
    onMinus = props.onMinus,
    onSearch = props.onSearch,
    MinusButtonDis = props.MinusButtonDis,
    PlusButtonDis = props.PlusButtonDis,
    startIconClassName = props.startIconClassName,
    inputTextCenter = props.inputTextCenter,
    readOnly = props.readOnly,
    select = props.select,
    endIcon = props.endIcon,
    active = props.active,
    inputClassName = props.inputClassName,
    requestSearchClose = props.requestSearchClose,
    autoFocus = props.autoFocus,
    inputID = props.inputID,
    outlinedInputClassName = props.outlinedInputClassName,
    startText = props.startText,
    simAdmin = props.simAdmin,
    multiline = props.multiline,
    setting = props.setting,
    autoComplete = props.autoComplete,
    isFleetaCameraSearch = props.isFleetaCameraSearch,
    onClear = props.onClear,
    restProps = _objectWithoutProperties(props, _excluded);
  var theme = (0, _styles.useTheme)();
  var classes = useStyle(props);
  var _useState = (0, _react.useState)(!password),
    _useState2 = _slicedToArray(_useState, 2),
    showPassword = _useState2[0],
    setShowPassword = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  var handleClickShowPassword = function handleClickShowPassword() {
    setShowPassword(function (s) {
      return !s;
    });
  };
  var getHelperTextColor = (0, _react.useCallback)(function () {
    if (error) {
      return "".concat(_pittaModules.LightColors.secondary["11"]);
    } else if (disabled) {
      return "".concat(_pittaModules.LightColors.primary["2"], "5A");
    } else {
      return "".concat(_pittaModules.LightColors.primary["2"]);
    }
  }, [error, disabled]);
  var getProgressNum = (0, _react.useCallback)(function () {
    if (mode === "fail") {
      return 39;
    } else if (mode === "warning") {
      return 61.5;
    } else if (mode === "success") {
      return 100;
    } else {
      return 0;
    }
  }, [mode]);
  (0, _react.useEffect)(function () {
    if (requestSearchClose) {
      setOpen(false);
      onCloseSearch === null || onCloseSearch === void 0 ? void 0 : onCloseSearch();
    }
  }, [onCloseSearch, requestSearchClose]);
  (0, _react.useEffect)(function () {
    if (simAdmin) {
      setOpen(true);
      onOpenSearch === null || onOpenSearch === void 0 ? void 0 : onOpenSearch();
      if (inputID) {
        var _document$getElementB;
        (_document$getElementB = document.getElementById(inputID)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.focus();
      }
    }
  }, [inputID, onOpenSearch, simAdmin]);
  var handleClickSearch = function handleClickSearch() {
    setOpen(true);
    onOpenSearch === null || onOpenSearch === void 0 ? void 0 : onOpenSearch();
    if (inputID) {
      var _document$getElementB2;
      (_document$getElementB2 = document.getElementById(inputID)) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.focus();
    }
  };
  var handleCloseSearch = function handleCloseSearch() {
    setOpen(false);
    onCloseSearch === null || onCloseSearch === void 0 ? void 0 : onCloseSearch();
  };
  var keyPress = function keyPress(e) {
    if (e.key === "Enter") {
      onSearch === null || onSearch === void 0 ? void 0 : onSearch();
    }
  };
  var getStartAdornment = function getStartAdornment() {
    if (isFleetaCameraSearch) {
      if (open) {
        var _clsx;
        return /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
          position: "start",
          className: classes.positionStart
        }, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
          color: SecondaryColor ? "secondary" : "default",
          className: (0, _clsx10.default)(classes.searchIcon, (_clsx = {}, _defineProperty(_clsx, classes.searchIconStandard, variant === "standard"), _defineProperty(_clsx, classes.searchIconCloseOulined, !open && variant !== "standard"), _clsx), startIconClassName),
          disabled: disabled,
          onClick: function onClick() {
            if (search && !simAdmin) {
              if (!open) {
                handleClickSearch();
              } else {
                if (isFleetaCameraSearch) {
                  handleCloseSearch();
                } else {
                  onSearch === null || onSearch === void 0 ? void 0 : onSearch();
                }
              }
            }
          }
        }, /*#__PURE__*/_react.default.createElement(_ArrowBackIos.default, null)));
      } else {
        var _clsx2;
        return startIcon ? /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
          position: "start",
          className: classes.positionStart
        }, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
          color: SecondaryColor ? "secondary" : "default",
          className: (0, _clsx10.default)(classes.searchIcon, (_clsx2 = {}, _defineProperty(_clsx2, classes.searchIconStandard, variant === "standard"), _defineProperty(_clsx2, classes.searchIconCloseOulined, !open && variant !== "standard"), _clsx2), startIconClassName),
          disabled: disabled,
          onClick: function onClick() {
            if (search && !simAdmin) {
              if (!open) {
                handleClickSearch();
              } else {
                if (isFleetaCameraSearch) {
                  handleCloseSearch();
                } else {
                  onSearch === null || onSearch === void 0 ? void 0 : onSearch();
                }
              }
            }
          }
        }, startIcon)) : startText ? /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
          category: "Default",
          variant: "Body"
        }, startText) : "";
      }
    } else {
      var _clsx3;
      return startIcon ? /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
        position: "start",
        className: classes.positionStart
      }, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
        color: SecondaryColor ? "secondary" : "default",
        className: (0, _clsx10.default)(classes.searchIcon, (_clsx3 = {}, _defineProperty(_clsx3, classes.searchIconStandard, variant === "standard"), _defineProperty(_clsx3, classes.searchIconCloseOulined, !open && variant !== "standard"), _clsx3), startIconClassName),
        disabled: disabled,
        onClick: function onClick() {
          if (search && !simAdmin) {
            if (!open) {
              handleClickSearch();
            } else {
              onSearch === null || onSearch === void 0 ? void 0 : onSearch();
            }
          }
        }
      }, startIcon)) : startText ? /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
        category: "Default",
        variant: "Body"
      }, startText) : "";
    }
  };
  var getEndAdornment = function getEndAdornment() {
    if (password) {
      return /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
        position: "end",
        className: classes.positionEnd
      }, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
        color: "secondary",
        "aria-label": "toggle password visibility",
        onClick: handleClickShowPassword,
        className: classes.showIcon,
        disabled: disabled,
        tabIndex: -1
      }, showPassword ? /*#__PURE__*/_react.default.createElement(_VisibilityOff.default, null) : /*#__PURE__*/_react.default.createElement(_Visibility.default, null)));
    } else if (isFleetaCameraSearch) {
      return open && !simAdmin && /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
        position: "end",
        className: classes.positionEnd
      }, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
        color: "secondary",
        onClick: function onClick() {
          return onClear === null || onClear === void 0 ? void 0 : onClear();
        },
        className: (0, _clsx10.default)(classes.showIcon),
        disabled: disabled
      }, /*#__PURE__*/_react.default.createElement(_Close.default, null)));
    } else if (search) {
      return open && !simAdmin && /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
        position: "end",
        className: classes.positionEnd
      }, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
        color: "secondary",
        onClick: handleCloseSearch,
        className: (0, _clsx10.default)(classes.showIcon),
        disabled: disabled
      }, /*#__PURE__*/_react.default.createElement(_Close.default, null)));
    } else if (defaultText) {
      return /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
        position: "end",
        className: classes.positionEnd
      }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
        category: "Default",
        variant: "Body",
        htmlColor: _pittaModules.LightColors.primary["3"],
        className: (0, _clsx10.default)(setting && classes.settingDefaultTextStyle)
      }, defaultText));
    } else {
      return endIcon;
    }
  };
  var getType = function getType() {
    if (password) {
      if (showPassword === true) {
        return "text";
      } else if (showPassword === false) {
        return "password";
      }
    }
    return type;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: rootRef,
    className: (0, _clsx10.default)(classes.textFiledWrap, className),
    style: style,
    dir: theme.direction
  }, function (_clsx4, _clsx5, _clsx6, _clsx8) {
    return (
      /*#__PURE__*/
      //@ts-ignore
      _react.default.createElement(_core.TextField, _extends({
        id: inputID,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        inputRef: ref
      }, restProps, {
        className: (0, _clsx10.default)(classes.root, (_clsx4 = {}, _defineProperty(_clsx4, classes.rootOpen, open), _defineProperty(_clsx4, classes.rootSearch, search), _clsx4)),
        onKeyDown: keyPress,
        variant: variant !== null && variant !== void 0 ? variant : "outlined",
        dir: theme.direction,
        disabled: disabled,
        error: error,
        multiline: multiline,
        fullWidth: true,
        type: getType(),
        label: label === undefined ? "" : /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
          category: "Default",
          variant: "Body"
        }, label),
        InputLabelProps: {
          classes: {
            root: classes.label,
            disabled: classes.disabled,
            error: classes.error,
            formControl: classes.formControl,
            shrink: classes.shrink
          }
        },
        inputProps: {
          pattern: pattern,
          inputMode: inputmode,
          maxLength: maxLength
        },
        InputProps: {
          classes: {
            root: (0, _clsx10.default)(classes.outlinedInput, outlinedInputClassName, (_clsx5 = {}, _defineProperty(_clsx5, classes.outlinedInputClose, search && !open && variant !== "standard"), _defineProperty(_clsx5, classes.outlinedInputOpen, open && variant !== "standard"), _defineProperty(_clsx5, classes.outlinedInputSetting, setting), _clsx5)),
            focused: (0, _clsx10.default)((_clsx6 = {}, _defineProperty(_clsx6, classes.focused, !error), _defineProperty(_clsx6, classes.focusedNotActive, !active && select), _defineProperty(_clsx6, classes.focusedErrorActive, error || active), _clsx6)),
            disabled: classes.disabled,
            error: classes.error,
            input: (0, _clsx10.default)(!multiline && classes.input, inputTextCenter && classes.inputCenter, inputClassName, _defineProperty({}, classes.inputSetting, setting)),
            notchedOutline: variant === "standard" ? undefined : (0, _clsx10.default)(classes.notchedOutline, (_clsx8 = {}, _defineProperty(_clsx8, classes.notchedOutlineOpen, open), _defineProperty(_clsx8, classes.notchedOutlineActive, active), _clsx8)),
            //@ts-ignore
            underline: (0, _clsx10.default)(search && variant === "standard" && classes.inputSearchUnderline)
          },
          startAdornment: getStartAdornment(),
          endAdornment: getEndAdornment(),
          readOnly: readOnly
        },
        helperText: helperText && /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
          category: "Default",
          variant: "Caption",
          htmlColor: getHelperTextColor()
        }, helperText),
        FormHelperTextProps: {
          classes: {
            root: (0, _clsx10.default)(classes.helperText, helperTextNoWrap && classes.nowrap, _defineProperty({}, classes.adminHelperText, simAdmin))
          }
        }
      }))
    );
  }(), count && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "outlined",
    color: "primary",
    disabled: MinusButtonDis,
    className: classes.buttonDisabled,
    style: {
      borderRadius: 0,
      borderLeft: 0,
      borderRight: 0,
      marginTop: typeof helperText === "string" ? -1 : "",
      minWidth: 44,
      maxHeight: typeof helperText === "string" ? 45 : ""
    },
    onClick: onMinus
  }, "\u2212"), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "outlined",
    color: "primary",
    disabled: PlusButtonDis,
    className: (0, _clsx10.default)(classes.buttonDisabled, classes.btnPlus),
    style: theme.direction === "rtl" ? {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      marginTop: helperText ? -1 : "",
      minWidth: 44,
      maxHeight: helperText ? 45 : ""
    } : {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      marginTop: helperText ? -1 : "",
      minWidth: 44,
      maxHeight: helperText ? 45 : ""
    },
    onClick: onPlus
  }, "+")), countDense && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "outlined",
    color: "primary",
    disabled: MinusButtonDis,
    className: (0, _clsx10.default)(classes.buttonDisabled, classes.pd910),
    style: {
      borderRadius: 0,
      borderLeft: 0,
      borderRight: 0,
      marginTop: typeof helperText === "string" ? -1 : "",
      minWidth: 36,
      maxHeight: typeof helperText === "string" ? 45 : ""
    },
    onClick: onMinus
  }, "\u2212"), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "outlined",
    color: "primary",
    disabled: PlusButtonDis,
    className: (0, _clsx10.default)(classes.buttonDisabled, classes.pd910),
    style: theme.direction === "rtl" ? {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      marginTop: typeof helperText === "string" ? -1 : "",
      minWidth: 36,
      maxHeight: typeof helperText === "string" ? 45 : ""
    } : {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      marginTop: typeof helperText === "string" ? -1 : "",
      minWidth: 36,
      maxHeight: typeof helperText === "string" ? 45 : ""
    },
    onClick: onPlus
  }, "+")), createPW && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.progressWrap
  }, /*#__PURE__*/_react.default.createElement(_core.LinearProgress, {
    variant: "determinate",
    value: getProgressNum(),
    classes: {
      root: classes.progress,
      colorPrimary: classes.colorPrimary,
      bar: classes.bar
    }
  })));
});
var _default = Input;
exports.default = _default;